import { Address } from '../../../../../../../app/types/scheduling'
import { SCHEDULING_SOURCE } from '../../../../../global/constants/scheduler'

export const getBrands = () => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/brands`,
  }
}

export const getBrandYears = (brand: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/years?brand=${brand}`,
  }
}

export const getModels = (brand: string, year: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/vehicles/models?brand=${brand}&year=${year}`,
  }
}

export const getVariants = (brand: string, year: string, model: string) => {
  const encodedModel = encodeURIComponent(model)
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/vehicles/variants?brand=${encodeURIComponent(
      brand,
    )}&year=${encodeURIComponent(year)}&model=${encodedModel}`,
  }
}

export const getIsVehicleBlacklisted = (
  brand: string,
  model: string,
  year: string,
) => {
  const encodeModel = encodeURIComponent(model)
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/vehicles/is-vehicle-blacklisted?brand=${encodeURIComponent(
      brand,
    )}&model=${encodeModel}&year=${year}`,
  }
}

export const getAvailabilityCalendar = (
  address: any,
  numberOfTires: number,
  serviceObjectId: string,
  source: SCHEDULING_SOURCE,
  fromDateOverride?: number,
  dontTrackSchedulingPerformance: boolean = false,
) => {
  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setUTCDate(today.getUTCDate() + 1)
  tomorrow.setUTCHours(0, 0, 0, 0)

  const fromDate = Number(fromDateOverride || tomorrow.getTime())

  return {
    method: 'POST',
    body: {
      address: address,
      numberOfTires: numberOfTires,
      serviceObjectIds: [serviceObjectId],
      fromDate,
      dontTrackSchedulingPerformance,
    },
    headers: {
      source: source,
    },
    url: `${process.env.REACT_APP_ORIGIN}/scheduling/available-calendar`,
  }
}

export const getAvailableCalendarForOrder = (
  orderId: string,
  source: SCHEDULING_SOURCE,
  daysFromEarliestAvailableDate?: number,
  fromDate?: number,
  toDate?: number,
) => {
  const params = new URLSearchParams()
  if (daysFromEarliestAvailableDate !== undefined)
    params.append(
      'daysFromEarliestAvailableDate',
      String(daysFromEarliestAvailableDate),
    )
  if (fromDate !== undefined) params.append('fromDate', String(fromDate))
  if (toDate !== undefined) params.append('toDate', String(toDate))
  const query = params.toString() ? `?${params.toString()}` : ''
  return {
    method: 'GET',
    headers: {
      source: source,
    },
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/available-calendar${query}`,
  }
}

export const updateCustomer = (body: any) => {
  return {
    method: 'PUT',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/customers`,
  }
}

export const updateCustomerVehicle = (body: any) => {
  return {
    method: 'PUT',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/customer_vehicles`,
  }
}
export const createCustomerVehicle = (body: any, customerId: string) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/customer_vehicles/${customerId}`,
    body: body,
  }
}

export const setCustomerVehicle = (
  orderId: string,
  vehicleObjectId: string,
) => {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/vehicles/bulk`,
    body: [vehicleObjectId],
  }
}

export const createInstallationPoint = (body: any) => {
  return {
    method: 'POST',
    body: body,
    url: `${process.env.REACT_APP_ORIGIN}/installation_point`,
  }
}

export const setInstallationPoint = (
  installationPoint: any,
  orderId: string,
) => {
  return {
    method: 'POST',
    body: installationPoint,
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/installation-point`,
  }
}
export const updateInstallationPoint = (body: any) => {
  return {
    method: 'PUT',
    body,
    url: `${process.env.REACT_APP_ORIGIN}/installation_point`,
  }
}
export const getStateByZip = (zipCode: string) => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/zips/${zipCode}/states`,
  }
}

export function getAddressValidation(address: Address) {
  return {
    method: 'POST',
    url: `${process.env.REACT_APP_ORIGIN}/scheduling/address-validation`,
    body: address,
  }
}
